import React, { Component } from 'react'
import $ from 'jquery';

class Setlangfunc extends Component{    

    componentDidMount = () => {        

        $( ".user-lang" ).click(function( event ) {
            // console.log( "Handler for .submit() called." );            
            // console.log( "Now sumbitting form" );
            event.preventDefault();
            $( "#userlang" ).submit();
        });
    }

    render(){
        return(
            <React.Fragment></React.Fragment>
        );
    }
}

export default Setlangfunc;